import { isBefore, subMonths } from "date-fns";

import { FILTER } from "@/constants";
import { hasValidFilters } from "@/containers/Filters/utils";
import { useEpisodes } from "@/contexts/EpisodesContext";
import { useMentionCards } from "@/contexts/MentionCardsContext";
import useFilterParams from "@/hooks/useFilterParams";
import TextButton from "@components/TextButton";
import Typography from "@components/Typography";

import styles from "./MoreMentionsHint.module.css";

const MoreMentionsHint: React.FC<{ v4?: boolean }> = ({ v4 = false }) => {
  const legacyEpisodesResult = useEpisodes();
  const mentionCardsResult = useMentionCards();
  const [filters, setFilters] = useFilterParams();

  const meta = v4 ? mentionCardsResult.meta : legacyEpisodesResult.meta;
  const alert = v4 ? mentionCardsResult.alert : legacyEpisodesResult.alert;

  const isLastPage = (filters[FILTER.PAGE] || 1) === meta?.page_count;
  const startDateIsAlertStart =
    alert?.start_date && filters[FILTER.START_DATE] == alert?.start_date;

  const startDateWithin3Months =
    filters[FILTER.START_DATE] === undefined &&
    alert?.start_date &&
    isBefore(subMonths(new Date(), 3), new Date(alert?.start_date));

  // Return null if ...
  if (
    // ... we've got no meta
    !meta ||
    // ...this is not the last page
    !isLastPage ||
    // ...the filtered start date is as far back as we can go
    startDateIsAlertStart ||
    // ... the date is not filtered, but the alert is not older than 3 months
    startDateWithin3Months ||
    // ... no filters are used
    !hasValidFilters(filters)
  ) {
    return null;
  }

  return (
    <div className={styles.root}>
      <Typography block align="center">
        {L.ALERT_FILTERED_FEED_NOTICE_TITLE}
        <br />
        <TextButton
          onClick={() => setFilters({ start_date: alert?.start_date }, true)}
        >
          {L.ALERT_FILTERED_FEED_NOTICE_LINK}
        </TextButton>
      </Typography>
    </div>
  );
};

export default MoreMentionsHint;
